export const LOCALE_PREFIX = 'scenes.Login'
